import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, Users } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const WorkloadView = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/rfp/response/workload`, { withCredentials: true })
      .then(r => setData(r.data))
      .catch(() => setData({ reps: [], unassigned_open: 0, total_open: 0 }));
  }, []);

  if (!data) return <Loader2 className="w-5 h-5 animate-spin text-[#4ABFCF]" data-testid="rfp-workload-loading" />;
  const max = Math.max(...data.reps.map(r => r.open), 1);
  return (
    <div className="space-y-3" data-testid="rfp-workload-view">
      <div className="flex items-center gap-2 text-[11px] text-slate-500" data-testid="rfp-workload-summary">
        <Users className="w-3.5 h-3.5 text-[#4ABFCF]" />
        <span><b className="text-[#0F2040]">{data.total_open}</b> open questions across open RFPs</span>
        <span>·</span>
        <span className={data.unassigned_open > 0 ? 'text-amber-600 font-semibold' : ''} data-testid="rfp-workload-unassigned">
          {data.unassigned_open} unassigned
        </span>
        <span className="flex-1" />
        <span className="text-[10px] text-slate-400">Balance the load here before bulk-assigning</span>
      </div>
      {data.reps.length === 0 && (
        <p className="text-sm text-slate-400 py-8 text-center" data-testid="rfp-workload-empty">
          Nothing assigned yet — select questions in a project and use the bulk bar to assign them.
        </p>
      )}
      <div className="space-y-2">
        {data.reps.map(r => (
          <div key={r.email} className="border border-slate-200 rounded-md px-3 py-2" data-testid={`rfp-workload-rep-${r.email}`}>
            <div className="flex items-center gap-2">
              <span className="text-xs font-semibold text-[#0F2040] w-64 truncate">{r.name || r.email}</span>
              <div className="flex-1 h-2.5 bg-slate-100 rounded overflow-hidden">
                <div className="h-full bg-[#0F2040]" style={{ width: `${(r.open / max) * 100}%` }} />
              </div>
              <span className="text-[11px] font-bold text-[#0F2040] w-16 text-right">{r.open} open</span>
              <span className="text-[10px] text-slate-400 w-16 text-right">{r.done} done</span>
            </div>
            {r.projects.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-1.5 pl-1">
                {r.projects.map(p => (
                  <span key={p.name} className="text-[9px] text-slate-500 bg-slate-50 border border-slate-200 rounded-full px-2 py-0.5">
                    {p.name} · {p.open}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
